import React from 'react';
import { A1AlertsProps } from './A1Alerts.types';
import { GetAlertModel } from './A1Alerts.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { Alert } from '@ahc-digital/component-library';
import { GetServerSideComponentProps } from '@sitecore-jss/sitecore-jss-nextjs';
import { ALERT_COOKIE } from 'src/shared/static';
import { LayoutServiceDataExtensions } from 'src/shared/shared.types';

export const Default = (props?: A1AlertsProps): JSX.Element => {
  const limit = 3;

  return (
    <>
      {props?.fields?.alerts?.value?.slice(0, limit).map((a, index) => {
        const isDismissed = props?.dismissedAlerts?.includes(getCookieName(a.uid));
        const model = GetAlertModel(a, isDismissed);

        return (
          <Alert
            key={index}
            id={props.params?.AnchorLinkTargetName}
            className={translationClasses(props.params)}
            {...model}
          />
        );
      })}
    </>
  );
};

export const getCookieName = (uid?: string) => {
  return ALERT_COOKIE + '_' + uid;
};

export const getServerSideProps: GetServerSideComponentProps = async (
  _rendering,
  layoutData,
  context
) => {
  const cookieNames = (
    layoutData?.sitecore as unknown as LayoutServiceDataExtensions
  ).context?.alerts?.value?.map((uid) => {
    const name = getCookieName(uid);

    if (context?.req?.cookies?.[name]) return name;

    return null;
  });

  return { dismissedAlerts: cookieNames };
};
